import React, {useState} from 'react';
import { CodeBlock, dracula } from "react-code-blocks";
import {getLocnIdfromH3Id, getH3IdfromLocnId} from "../locn/locn-utility";
import { useQueryParam,NumberParam,StringParam, withDefault } from 'use-query-params'

const H3ToLocnId = () => {
    const [locnId, setLocnId] = useQueryParam(
        'locnId',
        withDefault(StringParam, '3fzaq7y9g-19135'),
      );

      const [h3cellId, setH3cellId] = useQueryParam(
        'h3cellId',
        withDefault(StringParam, '8d618925b344abf'),
      );  


    const language = 'javascript';
    const showLineNumbers = true;
    const code = `
    const getLocnIdfromH3Id = (h3CellString) => {
        const h3CellStringLast4 = h3CellString.substring(h3CellString.length - 4);
        const h3CellStringFirstPart = h3CellString.substring(0, h3CellString.length - 4);
        const locnIdFirstPart = parseInt(h3CellStringFirstPart,16).toString(36);
        const locnIdLast5 = parseInt(h3CellStringLast4,16).toString().padStart(5,0);
        return locnIdFirstPart + '-' + locnIdLast5;
    }
    
    const getH3IdfromLocnId = (locnIdString='3fzaq7y9g-19135') => {
        const [locnIdStringFirstPart, locnIdStringLastPart] = locnIdString.split('-');
        const h3CellIdFirstPart = parseInt(locnIdStringFirstPart,36).toString(16).padStart(11,0);
        const h3CellIdLastPart = parseInt(locnIdStringLastPart,10).toString(16).padStart(4,0);
        const h3CellId = h3CellIdFirstPart + h3CellIdLastPart;
        return h3CellId;
    }
    `;
    const handleValueChange = (e) => {
        const { name, value } = e.target;
        console.log(name);
        console.log(value);
        if (name == 'h3CellId') {
            setH3cellId(value);
            setLocnId(getLocnIdfromH3Id(value));
        }else if (name == 'locnId') {
            setLocnId(value);
            setH3cellId(getH3IdfromLocnId(value));
        }

    }
    const firstBoxContent = () => {
        return (
            <>
            <div><b>Converting h3CellId to locn-id</b>
            <p>To make it easy to remember the idea is to create locnId which will have the last 5 characters as numbers and the remaining as alphanumeric.</p>
            </div>
            <div>
            <p>&nbsp;</p>    
            <p><strong>An example</strong></p>
            <p>h3cellId - <button className="bg-gray-200" name="h3CellId" type="button" onClick={handleValueChange} value='8d618925b344abf'>8d618925b344abf</button></p>
            <p>locn Id : <button className="bg-gray-200" name="locnId" type="button" onClick={handleValueChange} value='3fzaq7y9g-19135'>3fzaq7y9g-19135</button></p>
            <p>&nbsp;</p>
            <p>h3cellId is always a 15 character hexadecimal string(base16). Break the&nbsp;h3cellId in this case 8d618925b344abf into two halves. The first part&nbsp;is 11 characters and the second&nbsp;part&nbsp;is 4 characters.&nbsp;</p>
            <p>&nbsp;</p>
            So for the follwoing
            <p>8d618925b34-4abf</p>
            <p>&nbsp;</p>
            <p>first part -&nbsp;8d618925b34</p>
            <p>second part -&nbsp;4abf</p>
            <p>&nbsp;</p>
            <p>convert the first part from base 16 to base 36 -<a target='_blank' href="http://https://www.unitconverters.net/numbers/hexadecimal-to-base-36.htm" rel="noreferrer">&nbsp;https://www.unitconverters.net/numbers/hexadecimal-to-base-36.htm</a> you get&nbsp;3FZAQ7Y9G</p>
            <p>&nbsp;</p>
            <p>convert second part from base 16 to base 10 -&nbsp;<a target='_blank' href="https://www.unitconverters.net/numbers/hexadecimal-to-base-10.htm" rel="noreferrer">https://www.unitconverters.net/numbers/hexadecimal-to-base-10.htm</a> you get&nbsp;19135</p>
            <p>&nbsp;</p>
            <p>combining both you get locn Id = 3fzaq7y9g-19135</p>
            <p>&nbsp;</p>
            <p><b>Some other samples</b></p>
            <p>h3cellId - <button className="bg-gray-200" name="h3CellId" type="button" onClick={handleValueChange} value='8d618925b34433f'>8d618925b34433f</button></p>
            <p>locn Id : <button className="bg-gray-200" name="locnId" type="button" onClick={handleValueChange} value='3fzaq7y9g-17215'>3fzaq7y9g-17215</button></p>
            <p>&nbsp;</p>
            <p>h3cellId - <button className="bg-gray-200" name="h3CellId" type="button" onClick={handleValueChange} value='8d618925b34437f'>8d618925b34437f</button></p>
            <p>locn Id : <button className="bg-gray-200" name="locnId" type="button" onClick={handleValueChange} value='3fzaq7y9g-17279'>3fzaq7y9g-17279</button></p>
            <p>&nbsp;</p>
            <p>For fetching more pairs visit -&nbsp;<a target='_blank' href="/locn-vvpuram">/locn-vvpuram</a></p>
            <p>You can click on any dark grey entries to check the corresponding pairs for them</p>
            </div>
            </>
        );
    }
    return (
    <>
        <div className="grid grid-cols-6 gap-6">
            <div className="bg-gray-100 col-span-3 sm:col-span-3 p-4">
                {firstBoxContent()}
            </div>
            <div className="bg-gray-100 col-span-3 sm:col-span-3 p-4">
                <CodeBlock
                text={code}
                language={language}
                showLineNumbers={showLineNumbers}
                theme={dracula}
                />
                <div>
                    <div className='col-span-3 sm:col-span-3 p-2'>
                        <label style={{display:"inline-block", textAlign:"right"}}>h3CellID : &nbsp;</label>  
                        <input type="text" name="h3CellId" value={h3cellId} onChange={handleValueChange} />
                    </div>
                    <div className='col-span-3 sm:col-span-3 p-2'>
                        <label style={{display:"inline-block", textAlign:"right"}}>locnId : &nbsp;</label>  
                        <input type="text" name="locnId" value={locnId} onChange={handleValueChange} />
                    </div>
                    <div>Click on any h3cellId or locn Id from the left box. (The ones in dark grey)</div>
                </div>
            </div>
        </div>    
    </>
    );
    
}

export default H3ToLocnId;